import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'kes' })
export class KesPipe implements PipeTransform {
  transform(value: number | string): string {
    if (value === null || value === undefined || value === '') {
      return '—';
    }
    const amount = Number(value);
    return isFinite(amount) ? 'KES ' + amount.toLocaleString('en-KE', {
      minimumFractionDigits: 2, maximumFractionDigits: 2
    }) : '—';
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/kes.pipe.ts